var AVATAR_SIZES = {
  24: {
    icon: 16,
    label: 12,
    lineHeight: 12
  },
  28: {
    icon: 20,
    label: 14,
    lineHeight: 16
  },
  32: {
    icon: 24,
    label: 14,
    lineHeight: 16
  },
  36: {
    icon: 24,
    label: 16,
    lineHeight: 20
  },
  48: {
    icon: 36,
    label: 24,
    lineHeight: 32
  },
  72: {
    icon: 48,
    label: 32,
    lineHeight: 40
  },
  96: {
    icon: 72,
    label: 40,
    lineHeight: 48
  },
  144: {
    icon: 96,
    label: 72,
    lineHeight: 84
  }
};
export default AVATAR_SIZES;